import PropTypes from 'prop-types';
import React from 'react';

import { AriaRoles } from '../../../constants/AccessibilityConstants';
import { SourceCardCSSConstants } from '../../../constants/SourceCard';

import './SourceCardSubMenuItem.scss';

class SourceCardSubMenuItem extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    pandoraId: PropTypes.string,
    menuItemClicked: PropTypes.func,
    renderHr: PropTypes.bool,
    qaTag: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  renderHorizontalRule(shouldRenderHr) {
    if (shouldRenderHr) {
      return <hr className='SourceCard__hr' />;
    }
  }

  render() {
    const { name, title, text, pandoraId, qaTag, renderHr, menuItemClicked } = this.props;
    const itemClassName = SourceCardCSSConstants.SUBMENUCLASSNAME;

    return (
      <button
        key={`${name}${pandoraId}`}
        type='button'
        className={`${itemClassName}__button`}
        onClick={menuItemClicked}
        role={AriaRoles.MENUITEM}
        data-qa={qaTag}
        title={title}
      >
        <div className={`${itemClassName}__div`} aria-hidden={true}>
          {text}
        </div>
        {this.renderHorizontalRule(renderHr)}
      </button>
    );
  }
}

export default SourceCardSubMenuItem;
